import * as types from './mutation-types'
import {
  setShareSurvey
} from '../utils/cache'

const mutations = {
  [types.SET_SURVEY_ROLE](state, payload) {
    state.surveyRole = payload
  },
  [types.SET_ROLE](state, payload) {
    state.role = payload
  },
  [types.SET_ATTENTION](state, payload) {
    state.attention = payload
  },
  [types.SET_GUIDE_PAGE](state, payload) {
    state.guidePage = payload
  },
  [types.SET_SURVEY_TYPE](state, payload) {
    state.surveyType = payload
  },
  setShareSurvey(state, payload) {
    setShareSurvey(payload)
    state.shareSurvey = payload
  },
  setUserInfo(state,payload){
    state.userInfo = payload
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js